// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  DOCTOR: 'doctor',
  STAFF: 'staff',
};

// Donor request statuses
export const DONOR_REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REFERRED: 'referred',
  ACCEPTED: 'accepted',
  CANCELLED: 'cancelled',
  WAITING_BANK_APPROVAL: 'waiting_bank_approval',
};

// Donor statuses
export const DONOR_STATUS = {
  ALLOTTED: 'allotted',
  REFERRED: 'referred',
  S2S_ACCEPTED: 's2s_accepted',
  PENDING: 'pending',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

// Document statuses
export const DOCUMENT_STATUS = {
  UPLOADED: 'uploaded',
  PENDING: 'pending',
  SIGNED: 'signed',
  COMPLETED: 'completed',
  UNNEEDED: 'unneeded',
};

// Blood groups
export const BLOOD_GROUPS = [
  'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'
];

// Gender options
export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

// Marital status options
export const MARITAL_STATUS_OPTIONS = [
  { value: 'married', label: 'Married' },
  { value: 'single', label: 'Single' },
  { value: 'divorced', label: 'Divorced' },
];

// Donor types
export const DONOR_TYPES = {
  OOCYTE: 'oocyte',
  SEMEN: 'semen',
};

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  REMEMBERED_EMAIL: 'rememberedEmail',
  REMEMBERED_PASSWORD: 'rememberedPassword',
};
